  /*
  * Palo Alto Theme
  *
  * Botaneva custom JavaScript
  */

  (function () {

    // ==================================================
    // SHIPPING INSURANCE
    // ==================================================

    const SELECTORS = {
      checkbox: '[data-shipping-insurance-checkbox]',
      widget: '[data-shipping-insurance]',
    };

    let isUpdating = false;

    function getVariantId(checkbox) {
      const widget = checkbox.closest(SELECTORS.widget);

      return widget
        ? widget.getAttribute('data-shipping-insurance-variant')
        : null;
    }

    function refreshCart() {
      if (
        window.cart &&
        typeof window.cart.getCart === 'function'
      ) {
        window.cart.getCart();
        return;
      }

      window.location.reload();
    }


    // ==================================================
    // MARKET-AWARE CART URL
    // ==================================================

    function getMarketCartUrl() {

      if (
        window.theme &&
        window.theme.routes &&
        window.theme.routes.root
      ) {
        return window.theme.routes.root + 'cart.js';
      }

      if (
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
      ) {
        return window.Shopify.routes.root + 'cart.js';
      }

      return '/cart.js';
    }


    // ==================================================
    // INSURANCE QUANTITY
    // ==================================================

    function enforceInsuranceMaxQty() {

      const widget =
        document.querySelector(SELECTORS.widget);

      if (!widget) {
        return Promise.resolve();
      }

      const variantId =
        widget.getAttribute(
          'data-shipping-insurance-variant'
        );

      if (!variantId) {
        return Promise.resolve();
      }

      return fetch(
        getMarketCartUrl(),
        {
          credentials: 'same-origin',
        }
      )

        .then(function (response) {
          return response.json();
        })

        .then(function (cart) {

          const insuranceItem =
            cart.items.find(function (item) {

              return (
                String(item.variant_id) ===
                String(variantId)
              );

            });

          if (
            !insuranceItem ||
            insuranceItem.quantity <= 1
          ) {
            return;
          }

          return fetch(
            window.theme.routes.cart_change_url,
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json',

                Accept:
                  'application/json',
              },

              body: JSON.stringify({
                id: variantId,
                quantity: 1,
              }),
            }
          )

            .then(function () {
              refreshCart();
            });

        })

        .catch(function () {});

    }


    // ==================================================
    // SYNC INSURANCE CHECKBOX
    // ==================================================

    function syncInsuranceCheckboxes() {

      const checkboxes =
        document.querySelectorAll(
          SELECTORS.checkbox
        );

      if (!checkboxes.length) {
        return;
      }

      const variantId =
        getVariantId(
          checkboxes[0]
        );

      if (!variantId) {
        return;
      }

      fetch(
        getMarketCartUrl(),
        {
          credentials: 'same-origin',
        }
      )

        .then(function (response) {
          return response.json();
        })

        .then(function (cart) {

          const inCart =
            cart.items.some(
              function (item) {

                return (
                  String(item.variant_id) ===
                  String(variantId)
                );

              }
            );

          checkboxes.forEach(
            function (checkbox) {

              checkbox.checked =
                inCart;

              checkbox.disabled =
                false;

            }
          );

          return enforceInsuranceMaxQty();

        })

        .catch(function () {

          checkboxes.forEach(
            function (checkbox) {

              checkbox.disabled =
                false;

            }
          );

        });

    }


    // ==================================================
    // ADD INSURANCE
    // ==================================================

    function addInsurance(variantId) {

      return fetch(
        getMarketCartUrl(),
        {
          credentials: 'same-origin',
        }
      )

        .then(function (response) {
          return response.json();
        })

        .then(function (cart) {

          const insuranceItem =
            cart.items.find(
              function (item) {

                return (
                  String(item.variant_id) ===
                  String(variantId)
                );

              }
            );

          if (insuranceItem) {

            if (
              insuranceItem.quantity === 1
            ) {
              return null;
            }

            return fetch(
              window.theme.routes.cart_change_url,
              {
                method: 'POST',

                headers: {
                  'Content-Type':
                    'application/json',

                  Accept:
                    'application/json',
                },

                body: JSON.stringify({
                  id: variantId,
                  quantity: 1,
                }),
              }
            )

              .then(function (response) {
                return response.json();
              });

          }

          return fetch(
            window.theme.routes.cart_add_url,
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json',

                Accept:
                  'application/json',
              },

              body: JSON.stringify({
                id: variantId,
                quantity: 1,
              }),
            }
          )

            .then(function (response) {
              return response.json();
            });

        });

    }


    // ==================================================
    // REMOVE INSURANCE
    // ==================================================

    function removeInsurance(variantId) {

      return fetch(
        window.theme.routes.cart_change_url,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json',
          },

          body: JSON.stringify({
            id: variantId,
            quantity: 0,
          }),
        }
      )

        .then(function (response) {
          return response.json();
        });

    }


    function onInsuranceChange(event) {

      const checkbox =
        event.target.closest(
          SELECTORS.checkbox
        );

      if (
        !checkbox ||
        isUpdating
      ) {
        return;
      }

      const variantId =
        getVariantId(checkbox);

      if (!variantId) {
        return;
      }

      isUpdating = true;

      checkbox.disabled = true;

      const request =
        checkbox.checked
          ? addInsurance(variantId)
          : removeInsurance(variantId);

      request

        .then(function (response) {

          if (
            response &&
            response.status
          ) {

            checkbox.checked =
              !checkbox.checked;

            return;
          }

          refreshCart();

        })

        .catch(function () {

          checkbox.checked =
            !checkbox.checked;

        })

        .finally(function () {

          isUpdating = false;

          checkbox.disabled =
            false;

        });

    }


    document.addEventListener(
      'change',
      onInsuranceChange
    );

    document.addEventListener(
      'theme:cart:added',
      syncInsuranceCheckboxes
    );

    document.addEventListener(
      'theme:cart:loaded',
      syncInsuranceCheckboxes
    );


    // ==================================================
    // DISCOUNT CODE BANNER
    // ==================================================

    const DISCOUNT_BANNER = {

      root:
        '[data-discount-code-banner]',

      text:
        '[data-discount-code-banner-text]',

      storageKey:
        'botaneva_discount_banner_deadline',

      durationMs:
        10 * 60 * 1000,

    };


    function formatDiscountTimer(ms) {

      if (ms < 0) {
        ms = 0;
      }

      const totalSeconds =
        Math.floor(
          ms / 1000
        );

      const minutes =
        Math.floor(
          totalSeconds / 60
        );

      const seconds =
        totalSeconds % 60;

      return (
        minutes +
        ':' +
        (seconds < 10 ? '0' : '') +
        seconds +
        'min'
      );

    }


    function getDiscountDeadline() {

      const now =
        Date.now();

      let deadline =
        parseInt(
          sessionStorage.getItem(
            DISCOUNT_BANNER.storageKey
          ),
          10
        );

      if (
        !deadline ||
        isNaN(deadline) ||
        deadline <= now
      ) {

        deadline =
          now +
          DISCOUNT_BANNER.durationMs;

        sessionStorage.setItem(
          DISCOUNT_BANNER.storageKey,
          String(deadline)
        );

      }

      return deadline;

    }


    function getActiveDiscountCode(cart) {

      if (!cart) {
        return '';
      }

      if (
        Array.isArray(
          cart.discount_codes
        ) &&
        cart.discount_codes.length
      ) {

        const withCode =
          cart.discount_codes.find(
            function (entry) {

              return (
                entry &&
                entry.code
              );

            }
          );

        if (withCode) {
          return withCode.code;
        }

      }


      if (
        Array.isArray(
          cart.cart_level_discount_applications
        ) &&
        cart
          .cart_level_discount_applications
          .length
      ) {

        return (
          cart
            .cart_level_discount_applications[0]
            .title || ''
        );

      }


      if (
        Array.isArray(
          cart.discount_applications
        ) &&
        cart
          .discount_applications
          .length
      ) {

        return (
          cart
            .discount_applications[0]
            .title || ''
        );

      }

      return '';

    }


    function escapeHtml(value) {

      return String(
        value || ''
      )

        .replace(
          /&/g,
          '&amp;'
        )

        .replace(
          /</g,
          '&lt;'
        )

        .replace(
          />/g,
          '&gt;'
        )

        .replace(
          /"/g,
          '&quot;'
        )

        .replace(
          /'/g,
          '&#39;'
        );

    }


    function renderDiscountBannerText(
      banner,
      code,
      timer
    ) {

      const template =
        banner.getAttribute(
          'data-banner-template'
        ) || '';

      const textEl =
        banner.querySelector(
          DISCOUNT_BANNER.text
        );

      if (!textEl) {
        return;
      }

      textEl.innerHTML =
        escapeHtml(template)

          .replace(
            /\|\|code\|\|/g,
            '<strong>' +
              escapeHtml(code) +
              '</strong>'
          )

          .replace(
            /\|\|timer\|\|/g,
            '<strong>' +
              escapeHtml(timer) +
              '</strong>'
          );

    }


    function updateDiscountBanner(
      banner
    ) {

      const code =
        banner.getAttribute(
          'data-discount-code'
        ) || '';

      const hasCode =
        code.trim() !== '';

      banner.classList.toggle(
        'is-hidden',
        !hasCode
      );

      if (!hasCode) {
        return;
      }

      const remaining =
        getDiscountDeadline() -
        Date.now();

      if (
        remaining <= 0
      ) {

        sessionStorage.setItem(
          DISCOUNT_BANNER.storageKey,

          String(
            Date.now() +
            DISCOUNT_BANNER.durationMs
          )
        );

      }

      renderDiscountBannerText(
        banner,
        code,

        formatDiscountTimer(
          getDiscountDeadline() -
            Date.now()
        )
      );

    }


    function setDiscountBannerCode(
      banner,
      code
    ) {

      const nextCode =
        code || '';

      const prevCode =
        banner.getAttribute(
          'data-discount-code'
        ) || '';

      if (
        nextCode &&
        nextCode !== prevCode
      ) {

        sessionStorage.setItem(
          DISCOUNT_BANNER.storageKey,

          String(
            Date.now() +
            DISCOUNT_BANNER.durationMs
          )
        );

      }

      banner.setAttribute(
        'data-discount-code',
        nextCode
      );

      updateDiscountBanner(
        banner
      );

    }


    function syncDiscountBannerFromCart() {

      const banner =
        document.querySelector(
          DISCOUNT_BANNER.root
        );

      if (!banner) {
        return;
      }

      fetch(
        getMarketCartUrl(),
        {
          credentials:
            'same-origin',
        }
      )

        .then(function (response) {
          return response.json();
        })

        .then(function (cart) {

          setDiscountBannerCode(
            banner,
            getActiveDiscountCode(
              cart
            )
          );

        })

        .catch(function () {});

    }


    function initDiscountCodeBanner() {

      const banner =
        document.querySelector(
          DISCOUNT_BANNER.root
        );

      if (!banner) {
        return;
      }

      updateDiscountBanner(
        banner
      );

      setInterval(
        function () {

          updateDiscountBanner(
            banner
          );

        },
        1000
      );

      syncDiscountBannerFromCart();

    }


    document.addEventListener(
      'theme:cart:added',
      syncDiscountBannerFromCart
    );

    document.addEventListener(
      'theme:cart:loaded',
      syncDiscountBannerFromCart
    );


    if (
      document.readyState ===
      'loading'
    ) {

      document.addEventListener(
        'DOMContentLoaded',
        initDiscountCodeBanner
      );

    } else {

      initDiscountCodeBanner();

    }


    // ==================================================
    // HUNGARY STOREFRONT FALLBACK
    // ==================================================

    function isHungarianStorefront() {

      return (
        (
          document.documentElement.lang ||
          ''
        )
          .toLowerCase()
          .indexOf('hu') === 0
      );

    }


    function addHuBusinessDays(
      date,
      n
    ) {

      const d =
        new Date(
          date.getTime()
        );

      let added = 0;

      while (
        added < n
      ) {

        d.setDate(
          d.getDate() + 1
        );

        const dow =
          d.getDay();

        if (
          dow !== 0 &&
          dow !== 6
        ) {

          added++;

        }

      }

      return d;

    }


    function getHungarianDateSuffix(
      day
    ) {

      if (day === 1) {
        return '-jén';
      }

      const anDays = [
        2, 3, 6, 8,
        13, 16, 18,
        20, 23, 26, 28,
        30
      ];

      if (
        anDays.includes(day)
      ) {
        return '-án';
      }

      return '-én';

    }


    function renderHungarianStorefrontFixes() {

      if (
        !isHungarianStorefront()
      ) {
        return;
      }


      const huDays = [

        'vasárnap',
        'hétfőn',
        'kedden',
        'szerdán',
        'csütörtökön',
        'pénteken',
        'szombaton'

      ];


      const deliveryDate =
        addHuBusinessDays(
          new Date(),
          3
        );


      const day =
        deliveryDate.getDate();


      const dateStr =

        deliveryDate.getFullYear() +

        '.' +

        String(
          deliveryDate.getMonth() + 1
        ).padStart(
          2,
          '0'
        ) +

        '.' +

        String(
          day
        ).padStart(
          2,
          '0'
        );


      const dateSuffix =
        getHungarianDateSuffix(
          day
        );


      const dayName =

        huDays[
          deliveryDate.getDay()
        ];


      document
        .querySelectorAll(
          '[data-delivery-eta]'
        )
        .forEach(
          function (banner) {

            const textEl =
              banner.querySelector(
                '.product__delivery-eta__text'
              );

            if (textEl) {

              textEl.innerHTML =

                'Ha ma rendelsz, <strong>' +

                dateStr +

                dateSuffix +

                ', ' +

                dayName +

                '</strong> kiszállítjuk!';

            }

          }
        );


      document
        .querySelectorAll(
          '.vigo-trust-text'
        )
        .forEach(
          function (el) {

            const value =
              (
                el.textContent ||
                ''
              )
                .trim()
                .toLowerCase();


            if (
              value ===
                'eu warehouse' ||

              value ===
                'sklad v eu'
            ) {

              el.textContent =
                'EU raktár';

            }


            if (
              value ===
                'express delivery' ||

              value ===
                'expresní doručení'
            ) {

              el.textContent =
                'EXPRESSZ szállítás';

            }


            if (
              value ===
                'cash on delivery' ||

              value ===
                'na dobírku'
            ) {

              el.textContent =
                'Utánvétes fizetés';

            }

          }
        );


      document
        .querySelectorAll(
          'img'
        )
        .forEach(
          function (img) {

            const src =
              img.getAttribute(
                'src'
              ) || '';

            const alt =
              (
                img.getAttribute(
                  'alt'
                ) || ''
              )
                .toLowerCase();


            if (
              src.indexOf(
                'balikovna_transaprent.png'
              ) !== -1 ||

              alt ===
                'balikovna' ||

              alt ===
                'balíkovna'
            ) {

              img.src =
                'https://i.imgur.com/KPAQttc.png';

              img.alt =
                'Packeta';

              img.style.height =
                'auto';

              img.style.width =
                'clamp(40px, 10vw, 60px)';

            }

          }
        );

    }


    function initHungarianStorefrontFixes() {

      renderHungarianStorefrontFixes();

      setTimeout(
        renderHungarianStorefrontFixes,
        100
      );

      setTimeout(
        renderHungarianStorefrontFixes,
        700
      );

    }


    if (
      document.readyState ===
      'loading'
    ) {

      document.addEventListener(
        'DOMContentLoaded',
        initHungarianStorefrontFixes
      );

    } else {

      initHungarianStorefrontFixes();

    }

  })();


